/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2021 ООО АДАПТ info@acfs.spb.ru
 *
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import React, { FC } from 'react'

import { routes } from '@builddocs/data-management'
import { useTestAuth } from '@builddocs/data-management-auth'
import { CrossStorageHub } from 'cross-storage'
import { RouteProps } from 'react-router-dom'

import LoadingSpinner from './LoadingSpinner'

interface PrivateRouteProps extends RouteProps {
  component: React.ComponentType<any>
}

const PrivateRoute: FC<PrivateRouteProps> = ({ component: Component }) => {
  const { isAuth } = useTestAuth({
    loginUrl: routes.auth.signIn(),
    redirectUrlOnSuccess: routes.account.base(),
    isPrivateRoute: true,
  })
  // @ts-expect-error затычка
  const isDev = process.env.NODE_ENV === 'development'

  CrossStorageHub.init([
    {
      origin: /builddocs\.(team|online)$/,
      allow: ['get'],
    },
    {
      origin: /http:\/\/localhost:\d+$/,
      allow: ['get', 'set'],
    },
  ])

  return isAuth ? <Component /> : <LoadingSpinner isLogo />
}

export default PrivateRoute
